import { Hero } from "../components/home/Hero";
import { TrustSection } from "../components/home/TrustSection";
import { ServicesPreview } from "../components/home/ServicesPreview";
import { GoogleReviews, ReviewCTA } from "../components/home/GoogleReviews";
import { QuoteTeaser } from "../components/home/QuoteTeaser";
import { ProcessSection } from "../components/home/ProcessSection";
import { ServiceAreaSection } from "../components/home/ServiceAreaSection";
import { EmergencyBanner } from "../components/home/EmergencyBanner";
import { Testimonials } from "../components/home/Testimonials";
import { FAQSection } from "../components/home/FAQSection";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <TrustSection />
      <ServicesPreview />
      <GoogleReviews />
      <QuoteTeaser />
      <ProcessSection />
      <ServiceAreaSection />
      <EmergencyBanner />
      <Testimonials />
      <ReviewCTA />
      <FAQSection />
    </main>
  );
}
